<script>
import * as d3 from "d3"

const margin = {top: 20, right: 50, bottom: 0, left: 60},
        width = 375 - margin.left - margin.right,
        height = 275 - margin.top - margin.bottom

export default {
    props: {
        title: String,
        groups: Array,
        groupMembers: Array,
        data: Object
    },
    data() {
        return {
            margin: margin,
            width: width,
            height: height,
            groupScale: null,
            groupMemberScale: null,
            xScale: null
        }
    },
    created() {

        var y0 = d3.scaleBand()
            .rangeRound([height, 0])
            .padding(.2)

        y0.domain(this.groups)

        var y1 = d3.scaleBand()
            .padding(0.05)

        y1
            .domain(this.groupMembers.reverse())
            .rangeRound([0, y0.bandwidth()])

        this.groupScale = y0
        this.groupMemberScale = y1

        var x = d3.scaleLinear().range([0, width])

        x.domain([0, 4])

        this.xScale = x

        var colorScale = d3.scaleOrdinal()

        this.colorScale = colorScale.range(['#abbbcb', '#567797', '#2c557d'])

    },
    mounted() {

        var svg = d3.select(this.$refs['chart'])
        var container = d3.select(this.$refs['container'])

        var f = (a) => a.split('_')[0].slice(-2).toUpperCase()

        container
            .append('g')
                .attr('class', 'y-axis')
                .call(d3.axisLeft(this.groupScale).tickFormat(f))
    
    }
}
</script>
<template>
    <div class="horizontal-bar">
        <h3>{{title}}</h3>
        <svg ref="chart" :width="width + margin.left + margin.right" :height="height + margin.top + margin.bottom">
            <g ref="container" :transform="`translate(${margin.left}, ${margin.top})`">
                <g v-for="group in groups" :key="group" class="group" :transform="`translate(0, ${groupScale(group)})`">
                    <rect v-for="(item, i) in data[group]" :fill="colorScale(i)" :width="xScale(item.value)" :height="groupMemberScale.bandwidth()" :y="groupMemberScale(item.label)" :key="item.label"></rect>
                    <text v-for="(item, i) in data[group]" :key="i" :x="width" :y="groupMemberScale(item.label) + groupMemberScale.bandwidth()/1.5">{{item.value.toFixed(2)}}</text>
                </g>
            </g>
        </svg>
    </div>
</template>
<style lang="scss" scoped>
    .horizontal-bar {
        border: 1px solid #979797;
        margin-bottom: 1em;
        padding: 1em 2em;
        .y-axis {
            font-size: 2em;
            .domain {
                display: none;
            }
        }
    }
</style>